export const FIXED_SLUG = 'lista-actual' as const;
